import { PaymentType } from '../common/payment-type.enum';

 export class TrainDialogModel {
        trainUid: string;

        trainName: string;

        descr: string;

        // companyUid: string;

        companyNames: string;

        targetStoreUid: string;

        targetStoreName: string;

        targetStoreActive: boolean;

        priceSetting: number;

        isEnabled: boolean;

        cycleName: string;

        cycleUID: string;

        lastTrainInCycle: boolean;

        currenciesCash: string[];

        currenciesPaymentCard: string[];

        tnTrainCurrencies: any;

        tnTrainCycleTrains: any[];

        tnTrainParts: any[];
    }



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/train-dialog/train-dialog.model.ts